import React from 'react';
import { SiteShell } from '../components/landing/new/SiteShell';
import { HeroSection } from '../components/landing/new/HeroSection';
import { PipelineSection } from '../components/landing/new/PipelineSection';
import { DocumentSection } from '../components/landing/new/DocumentSection';
import { IntelligenceSection } from '../components/landing/new/IntelligenceSection';
import { StatsSection } from '../components/landing/new/StatsSection';
import { SafetySection } from '../components/landing/new/SafetySection';
import { ImpactSection } from '../components/landing/new/ImpactSection';
import { FinalCtaSection } from '../components/landing/new/FinalCtaSection';
import { MarketingFooter } from '../components/landing/new/MarketingFooter';

export default function LandingPage() {
  return (
    <SiteShell>
      <HeroSection />
      {/* Bolt-led productivity arc: ask → act → know → (safety) → ROI */}
      <IntelligenceSection />{/* Ask Bolt anything */}
      <PipelineSection />{/* Bolt takes action (agentic) */}
      <StatsSection />{/* Scale / depth band */}
      <DocumentSection />{/* Document intelligence */}
      <SafetySection />{/* The one dedicated safety/compliance section */}
      <ImpactSection />{/* Productivity ROI */}
      <FinalCtaSection />
      <MarketingFooter />
    </SiteShell>
  );
}
